import fetchApi from "../fetchApi";
import {DEFAULT_LIMIT} from "../../contstants";

export const GetCardholders = async (limit = DEFAULT_LIMIT, offset = 0 ,date_from = '', date_to = '') => {

    const options = {
        method: 'GET',
        headers: new Headers({
        }),
    }

    return await fetchApi(`card-issuing/cardholder?created_on_gte=${date_from}&created_on_lte=${date_to}&limit=${limit}&offset=${offset}`, options);
}